import React, { useEffect } from "react";
import Countdown from "react-countdown";
import styles from "./BackupSettings.module.css";
import Spinner from "@atlaskit/spinner";
import InfoIcon from "@atlaskit/icon/glyph/info";
import { API } from "../../utility/Api";
import { errorHandler } from "../../helpers/helpers";
import ArchiveIcon from "@atlaskit/icon/glyph/archive";
import Toggle from "@atlaskit/toggle";
import { Link } from "react-router-dom";
import { useState } from "react";
import { Radio } from "@atlaskit/radio";
import Tooltip from "@atlaskit/tooltip";
import { UseToast } from "../../components/context/ToastContext";
import RecentIcon from "@atlaskit/icon/glyph/recent";
import WarningIcon from "@atlaskit/icon/glyph/warning";
import Skeleton from "react-loading-skeleton";
import Button from "@atlaskit/button";
import LocationIcon from "@atlaskit/icon/glyph/location";
import Modal, {
  ModalBody,
  ModalFooter,
  ModalHeader,
  ModalTitle,
  ModalTransition,
} from "@atlaskit/modal-dialog";
import { CheckboxSelect } from "@atlaskit/select";
import moment from "moment";
import ProjectExclusionSetting from "../ProjectExclusionSetting/ProjectExclusionSetting";
const BackupSettings = (props) => {
  const [isLoading, setIsLoading] = useState(false);
  const [showConfirmation, setShowConfirmation] = useState(false);
  const [selectedval, setSelectedVal] = useState(false);
  // const [isError,setIsError]=useState(false)
  const setMainMessage = UseToast();

  const [backupToggle, setBackupToggle] = useState(false);

  useEffect(() => {
    const getBackupToggleDefault = async (token) => {
      setIsLoading(true);
      await API.get("api/pause-scheduled-backup", {
        headers: {
          Authorization: `JWT ${token}`,
        },
      })
        .then(function (response) {
          setBackupToggle(response.data.pauseScheduledBackup);
          setIsLoading(false);
        })
        .catch(function (error) {
          setIsLoading(false);
          setMainMessage({ text: error.message, appearance: "error" });
        });
    };
    // eslint-disable-next-line
    AP.context.getToken(function (token) {
      getBackupToggleDefault(token);
    });
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  const pauseBackuptoggleHandler = (props) => {
    setShowConfirmation(true);
    setSelectedVal(props);
  };
  const pauseBackupHandler = (props) => {
    setIsLoading(true);
    setBackupToggle(props);
    // eslint-disable-next-line
    AP.context.getToken(function (token) {
      setBackupToggleOnServer(token, props);
    });
    const setBackupToggleOnServer = async (token, props) => {
      await API.put(
        "api/pause-scheduled-backup",
        { pauseScheduledBackup: props },
        {
          headers: {
            Authorization: `JWT ${token}`,
          },
        }
      )
        .then(function (response) {
          setBackupToggle(response.data.pauseScheduledBackup);
          setIsLoading(false);
        })
        .catch(function (error) {
          setIsLoading(false);

          setBackupToggle(!props);
          const data = errorHandler(error);
          setMainMessage({ appearance: "error", text: data.message });
        });
    };
  };
  const renderer = ({ hours, minutes, seconds }) => {
    return (
      <span>
        {hours} Hrs {minutes} Mins {seconds} secs
      </span>
    );
  };
  let valForCountdown = 0;
  let startTime = moment.utc();
  let endTime = moment.utc().add(1, "days");
  endTime.set({ hour: 0, minute: 0, second: 0, millisecond: 0 });
  valForCountdown = endTime.diff(startTime);

  return (
    <div className={styles.container}>
      <ModalTransition>
        {showConfirmation && (
          <Modal onClose={() => setShowConfirmation(false)}>
            <ModalHeader>
              <ModalTitle>
                <div className={styles.aligncenter}>
                  {backupToggle ? (
                    "Resume"
                  ) : (
                    <div className={styles.aligncenter}>
                      <WarningIcon primaryColor="red" />
                      &nbsp; Pause
                    </div>
                  )}
                  <div>&nbsp;scheduled backups</div>
                </div>
                {isLoading && <Spinner />}
              </ModalTitle>
            </ModalHeader>
            <ModalBody>
              {backupToggle ? (
                <p>
                  Resuming scheduled backups will enable automated data
                  protection for your Jira Software.
                  <br />
                  <br /> Are you sure you want to proceed?
                </p>
              ) : (
                <p>
                  Pausing scheduled backups will stop automated data protection
                  for your Jira Software. It is recommended that you do not
                  pause scheduled backups.
                  <br />
                  <br />
                  Are you sure you want to proceed?
                </p>
              )}
            </ModalBody>
            <ModalFooter>
              <Button
                appearance={!backupToggle ? "primary" : "subtle"}
                onClick={() => setShowConfirmation(false)}
              >
                Cancel
              </Button>
              <Button
                type="submit"
                onClick={() => {
                  pauseBackupHandler(selectedval);
                  setShowConfirmation(false);
                }}
                appearance={!backupToggle ? "warning" : "primary"}
                autoFocus
              >
                {backupToggle ? "Resume" : "Pause"}
              </Button>
            </ModalFooter>
          </Modal>
        )}
      </ModalTransition>
      <div className={styles.settingTitle}>Backup Settings</div>
      <div className={styles.widgetcontainer}>
        <div className={styles.cardContainer}>
          <div className={styles.onkarwidget}>
            <div className={styles.iconcontainer}>
              <RecentIcon size="large" />
            </div>
            <div className={styles.widgetcontent}>
              <div className={styles.widgettitle}>
                <div className={styles.widgettitletext}>
                  <p>Scheduled backups &nbsp;</p>
                  <Tooltip
                    content="Revyz automatically backs up your data with the frequency show below."
                    position="top"
                  >
                    <div>
                      <InfoIcon primaryColor="grey" size="small" />
                    </div>
                  </Tooltip>
                </div>
                <div className={styles.spinnercontainer}>
                  {/* {isLoading&&<div className={styles.spinnercontainer}><Spinner /><p>Syncing...</p></div> } */}

                  <div className={styles.toggleicon}>
                    <Toggle
                      isDisabled={isLoading}
                      isChecked={!backupToggle}
                      onChange={(e) =>
                        pauseBackuptoggleHandler(!e.target.checked)
                      }
                      id="toggle-default"
                    />
                  </div>
                  <Tooltip
                    content="Turn off scheduled backups using the toggle"
                    position="top"
                  >
                    <div>
                      <InfoIcon primaryColor="grey" size="small" />
                    </div>
                  </Tooltip>
                </div>
              </div>
              <div style={{ marginTop: "10px" }}>
                {isLoading ? (
                  <Skeleton
                    width={"50%"}
                    count={1}
                    baseColor="lightgrey"
                    height={"10px"}
                  />
                ) : backupToggle ? (
                  <p className={styles.aligncenter}>
                    <WarningIcon primaryColor="red" />
                    Please turn on automatic backups to secure your system
                  </p>
                ) : (
                  <p>The next scheduled backup will be initiated in</p>
                )}
                {isLoading ? (
                  <Skeleton
                    width={"50%"}
                    count={1}
                    baseColor="lightgrey"
                    height={"10px"}
                  />
                ) : (
                  !backupToggle && (
                    <Countdown
                      renderer={renderer}
                      zeroPadTime={2}
                      date={startTime + valForCountdown}
                    />
                  )
                )}
              </div>
              <div className={styles.widgetactionarea}>
                {isLoading ? (
                  <Skeleton
                    width={"50%"}
                    count={1}
                    baseColor="lightgrey"
                    height={"10px"}
                  />
                ) : !backupToggle ? (
                  <div className={styles.widgetoptions}>
                    <p>Backup every: &nbsp;</p>
                    <Radio
                      value="default radio"
                      label="24Hrs"
                      name="radio-time"
                      testId="radio-default"
                      isChecked={true}
                      onChange={() => {}}
                    />
                  </div>
                ) : (
                  <div>{""}</div>
                )}
                <Link to="/backup/trigger">
                  <p className={styles.actiontitle}>Backup Now </p>
                </Link>
              </div>
            </div>
          </div>
          <div className={styles.onkarwidget}>
            <div className={styles.iconcontainer}>
              <ArchiveIcon size="large" />
            </div>
            <div className={styles.widgetcontent}>
              <div className={styles.widgettitle}>
                <div className={styles.widgettitletext}>
                  <p>Retention policy &nbsp;</p>
                  <Tooltip
                    content="Revyz backups are maintained on our servers for a limited time stated below"
                    position="top"
                  >
                    <div>
                      <InfoIcon primaryColor="grey" size="small" />
                    </div>
                  </Tooltip>
                </div>
              </div>
              <p>
                Your Revyz Backups will persist in our data storage for 1 Year{" "}
              </p>
              <div className={styles.widgetactionarea}>
                {/* <p className={styles.actiontitle}>Upgrade</p> */}
                <div className={styles.widgetoptions}>
                  <p>Keep data for: &nbsp;</p>
                  <Radio
                    value="default radio"
                    label="1 Yr"
                    name="year"
                    testId="radio-default"
                    isChecked={true}
                    onChange={() => {}}
                  />
                </div>
              </div>
            </div>
          </div>
          <div className={styles.onkarwidget}>
            <div className={styles.iconcontainer}>
              <LocationIcon size="large" />
            </div>
            <div className={styles.widgetcontent}>
              <div className={styles.widgettitle}>
                <div className={styles.widgettitletext}>
                  <div>Data storage region &nbsp;</div>
                  <Tooltip
                    content="Data storage location tells you the location of your data storage."
                    position="top"
                  >
                    <div>
                      <InfoIcon primaryColor="grey" size="small" />
                    </div>
                  </Tooltip>
                </div>
              </div>

              <div className={styles.widgetactionarea}>
                {/* <p className={styles.actiontitle}>Upgrade</p> */}
                <div className={styles.widgetoptions}>
                  <p>Your data is stored at &nbsp;</p>
                  <div className={styles.checkboxholder}>
                    <CheckboxSelect
                      isDisabled={true}
                      placeholder="US East (N. Virginia)"
                    />
                  </div>
                </div>
              </div>
              <p>&nbsp;</p>
            </div>
          </div>
        </div>
        <div>
          <ProjectExclusionSetting />
        </div>
      </div>
      {/* <div className={styles.imagecontainer}>
        <img
          style={{ width: "90%" }}
          src={placeholder}
          alt="placeholder-backups-history"
        />
      </div> */}
    </div>
  );
};

export default BackupSettings;
